let backendHost;
const apiVersion = 'v1';

const hostname = window && window.location && window.location.hostname;

if(hostname === 'rfi.pnnl.gov') {
  backendHost = 'https://rfi-api.pnnl.gov';
} else if(hostname === 'rfi-stage.pnnl.gov') {
  backendHost = 'https://rfi-api-stage.pnnl.gov';
} else if(hostname === 'rfi-test.pnnl.gov') {
  backendHost = 'https://rfi-api-test.pnnl.gov';
} else if(hostname === 'rfi-dev.pnnl.gov') {
  backendHost = 'https://rfi-api-dev.pnnl.gov';
} else if(hostname === 'rpmp-rfi.pnnl.gov') {
  backendHost = 'https://rfi-api.pnnl.gov';
} else if(hostname === 'rpmp-rfi-stage.pnnl.gov') {
  backendHost = 'https://rfi-api-stage.pnnl.gov';
} else if(hostname === 'rpmp-rfi-test.pnnl.gov') {
  backendHost = 'https://rfi-api-test.pnnl.gov';
} else if(hostname === 'rpmp-rfi-dev.pnnl.gov') {
  backendHost = 'https://rfi-api-dev.pnnl.gov';
} else {
  backendHost = 'https://rfi-api-dev.pnnl.gov'; //todo make this dynamic for feature branches
} 

export const apiUrl = `${backendHost}`;